import { combineReducers } from 'redux';
import navLayoutDimensionsState from '../NavLayoutDimensions/reducer';
import { navObjBuilderMenu, navObjBuilderMenuReducer } from '../components/ObjectCreateButton/reducer';
import overlayDisplayConfigState from '../overlayDisplayConfig/reducer';
import alerts from './Alerts';
import appConfig from './AppConfig';
import businessUnits from './BusinessUnits';
import experiments from './Experiments';
import { globalStylesReducer, globalStylesSliceName } from './GlobalStyles';
import onboardingProgress from './OnboardingProgress';
import portal from './Portal';
import portalAttributes from './PortalAttributes';
import translations from './Translations';
import user from './User';
import navItems from './navItems';
import portalUserAttributes from './portalUserAttributes';
import { inAppHelpReducer, inAppHelpSliceName } from '../external-contrib/in-app-help/reducers';
import { accountsDataReducer, accountsDataSliceName } from './AccountsData';
import { reducer as iaDetailsReducer, iaDetailsSliceName } from '../features/spotlight-onboarding-2025/slices/iaDetails.slice';
import { plpoExperienceReducer, plpoExperienceSliceName } from './PLPOExperience';
import { reducer as optinsReducer, optinsSliceName } from '../features/spotlight-onboarding-2025/slices/optins.slice';
import { reducer as invalidateNavConfigReducer, invalidateNavConfigSliceName } from '../features/spotlight-onboarding-2025/slices/invalidateNavConfig.slice';
export const rootReducer = combineReducers({
  navItems,
  portal,
  user,
  businessUnits,
  translations,
  portalAttributes,
  portalUserAttributes,
  experiments,
  onboardingProgress,
  appConfig,
  alerts,
  overlayDisplayConfigState,
  navLayoutDimensionsState,
  [iaDetailsSliceName]: iaDetailsReducer,
  [globalStylesSliceName]: globalStylesReducer,
  [navObjBuilderMenu]: navObjBuilderMenuReducer,
  [inAppHelpSliceName]: inAppHelpReducer,
  [accountsDataSliceName]: accountsDataReducer,
  [plpoExperienceSliceName]: plpoExperienceReducer,
  [optinsSliceName]: optinsReducer,
  [invalidateNavConfigSliceName]: invalidateNavConfigReducer
});